import { useState, useEffect } from "react";
import { usePrevious } from "../../utils/hooks/usePrevious";

/**
 * Manages the local copy of the Select controlled value.
 *
 * @param {object} params
 * @param {*}        params.value       - Controlled value from parent
 * @param {*}        params.shouldReset - When truthy (and changed), resets the local value
 * @param {string}   params.mode        - Ant Design Select mode ("multiple" or undefined)
 * @returns {{ localValue: *, setLocalValue: Function }}
 */
export const useSelectValue = ({ value, shouldReset, mode }) => {
  const [localValue, setLocalValue] = useState(value || undefined);

  const prevShouldReset = usePrevious(shouldReset);
  useEffect(() => {
    if (shouldReset && shouldReset !== prevShouldReset) {
      setLocalValue(mode === "multiple" ? [] : null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional: prevShouldReset is a ref-backed stale value used only for comparison
  }, [shouldReset, mode]);

  useEffect(() => {
    if (value !== localValue) {
      setLocalValue(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return { localValue, setLocalValue };
};
